module.exports = __webpack_public_path__ + "img/visu-et-vous@2x.09e7d9ac.jpg";